jQuery.fn.slideSelectorMenu = function() {
  let self = this
  self.selector = $('<div class="slide-selector-menu__selector"></div>')

  self.selected = function() {
    self.selector.css('left', ($(this).offset().left - self.offset().left) + 'px')
    self.selector.css('width', $(this).width() + 'px')
  }

  return function() {
    /* build */
    self.addClass("slide-selector-menu");
    self.append(self.selector);

    /* add event listeners */
    $(window).on('resize orientationchange load', function() {
      self.find('button[aria-selected=true]').click()
    })
    self.find('> button').on('click', self.selected)
    self.find('button[aria-selected=true]').click()
    return self
  }()
};
